import React from "react";

export const NoResults = () => {
  return (
    <div className="row">
      <div className="col-xs-12">
        <h4 className="h4 brand-color section-padding text-center">
          No results were found for your search.
          <br />
          Please try some different options.
        </h4>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// src/client/components/common/elements/NoResults.js